const isIeOrEdge = () => {
  const { userAgent } = window.navigator
  return /(Edge|MSIE|Trident)/i.test(userAgent)
}

export default isIeOrEdge
